if (document.querySelectorAll('[data-component="selectize"]').length > 0) {

    document.addEventListener('DOMContentLoaded', function () {

        $('[data-toggle="selectize"]').selectize();
    })
}